import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BaseStaticLayersGL } from '@rsos/components/capstone/common/Map/useDeckGL/StaticLayersGL/BaseStaticLayersGL';
import { psapSelector } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import {
  setMapCardData,
  setCardsToRender,
  STATIC_LAYERS_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import isSpatialLayersSummaryEnabled from '@rsos/utils/isSpatialLayersSummaryEnabled';
import { resolveSpatialObject } from '../../../../actions/spatialLayers';
import CRGGL from './CRGGL';

export const StaticLayersGL = ({ overlay, removedID, isMapIconDisabled }) => {
  const dispatch = useDispatch();
  const psaps = useSelector(psapSelector);

  // Check capability for optimized endpoints (per-agency)
  const hasOptimizedEndpoints = useMemo(
    () => isSpatialLayersSummaryEnabled(psaps),
    [psaps],
  );

  const handleBaseMarkerClick = useCallback(
    async (spatialObject, spatialLayer) => {
      // Show summary immediately
      dispatch(
        setMapCardData({
          layerData: spatialLayer,
          spatialObject: spatialObject,
        }),
      );
      dispatch(setCardsToRender(STATIC_LAYERS_CARD));

      // Fetch details
      const fullObject = await dispatch(
        resolveSpatialObject(spatialObject, hasOptimizedEndpoints),
      );

      // Update with details if available
      if (fullObject) {
        dispatch(
          setMapCardData({
            layerData: spatialLayer,
            spatialObject: fullObject,
          }),
        );
      }
    },
    [dispatch, hasOptimizedEndpoints],
  );

  return (
    <>
      <BaseStaticLayersGL
        overlay={overlay}
        isMapIconDisabled={isMapIconDisabled}
        onMarkerClick={handleBaseMarkerClick}
      />
      <CRGGL
        overlay={overlay}
        removedID={removedID}
        isMapIconDisabled={isMapIconDisabled}
      />
    </>
  );
};

export default StaticLayersGL;
